import React from 'react';

import { Carousel } from 'react-responsive-carousel';
import { T } from '../../../../../../../common/locale/translate';
import { fetchCuriosity } from '../../../../../services/services';

export default class Hints extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      pristine: true,
      current_index: 0,
      curiosities: this.props.curiosities || [],
      regions: this.props.regions,
      isSeo: this.props.isSeo,
      active: true,
      open: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.regions &&
      nextProps.regions !== this.state.regions &&
      this.state.active
    ) {
      if (typeof this.state.regions == 'undefined' && this.props.isSeo) {
        this.setState({ regions: nextProps.regions });
      } else {
        this.setState(
          { regions: nextProps.regions, isSeo: false, pristine: false },
          () => {
            this.updateHints();
          }
        );
      }
    }
  }

  render() {
    const is_seo =
        this.props.isSeo && this.props.seoDescription && this.state.pristine,
      curiosities = this.state.curiosities;
    return is_seo
      ? this.generateSeoDescription()
      : curiosities
        ? this.generateCuriosity()
        : '';
  }

  generateSeoDescription = () => {
    return (
      <div
        className={`content-header seo-description ${
          this.state.active ? 'active' : ''
        }`}
      >
        <div className="content-description seo">
          <i className="fa fa-times close-icon" onClick={this.closePanel} />
          <span className="offer-category last-minute">
            {' '}
            {T('domain_name')}{' '}
          </span>
          <p dangerouslySetInnerHTML={{ __html: this.props.seoDescription }} />
        </div>
      </div>
    );
  };

  generateCuriosity = () => {
    const curiosities = this.state.curiosities.map((curiosity, index) => (
      <div key={index} className="content-header">
        <div
          className={`content-description curiosity ${
            this.state.open ? 'open' : ''
          }`}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: `<span class="offer-category all-inclusive">${T(
                'do_you_know'
              )}</span> ${curiosity.content}`
            }}
          />
          <i className="fa fa-times close-icon" onClick={this.closePanel} />
          <div className="show-more-button" onClick={this.toggleHeight}>
            <div className="more-button-title">
              {this.state.open ? T('read_less') : T('read_more')}
              <i className={`fa fa-arrow-${this.state.open ? 'up' : 'down'}`} />
            </div>
          </div>
        </div>
      </div>
    ));
    return curiosities.length ? (
      <Carousel
        className={`curiosity-slider ${this.state.active ? 'active' : ''}`}
        showArrows={true}
        showThumbs={false}
        emulateTouch={true}
      >
        {curiosities}
      </Carousel>
    ) : (
      false
    );
  };

  closePanel = () => this.setState({ active: false });

  toggleHeight = () => this.setState({ open: !this.state.open });

  updateHints = () => {
    fetchCuriosity({ regions: this.state.regions }).then(
      response => {
        if (response.status == 204) {
          this.setState({ loader: false, curiosity: 'Kurde blaszka' });
        } else {
          this.setState({
            curiosities: response.data,
            curiosity: response.data[0],
            current_index: 0
          });
        }
      },
      () => {
        // TODO handle error
        this.setState({ error: true, current_state: 'pristine' });
      }
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/hints.js